const fontSize = 14; // px
const htmlFontSize = 10;
const coef = fontSize / 14;

const colours = {
  mono: {
    ultraDark: "#232A3C",
    superDark: "#232a3c",
    primaryDark: "#3B434B",
    secondaryDark: "#6E7378",
    gray: "#d8d8d8",
    mediumGray: "#EAEAEB",
    lightGray: "#F1F1F2",
    superLightGray: "#F8F8F8",
    maxLightGray: "#fafaff",
    washedBlue: "#f0f0fa",
    white: "#ffffff",
  },
  colour: {
    primaryBlue: "#1968B7",
    primaryBlueHover: "#4284C4",
    primaryBluePressed: "#1693DE",
    primaryBlueActive: "#124D86",
    cyan: "#0da6fd",
    green: "#18c914",
    purple: "#8c33fd",
    pink: "#fb78fe",
    orange: "#e75e1f",
    red: "#d00313",
    yellow: "#f5a615",
  },
};

const theme = {
  themeName: "Coretex Rodeo Standard",
  palette: {
    ...colours,
    primary: {
      light: "#bbddfb",
      main: "#1f86e4",
      dark: "#3f4b6c",
    },
    secondary: {
      main: "#f26523",
      dark: "#7d8696",
      light: "#f0f0fa",
    },
    error: {
      main: "#d00313",
      dark: "#b00020",
    },
    action: {
      selected: "rgba(31, 134, 228, 0.08)",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },

  typography: {
    fontFamily: `'Roboto', 'Helvetica', 'Arial', sans-serif`,
    htmlFontSize: 10,
    fontSize: 10,
    fontWeight: {
      light: 300,
      regular: 400,
      bold: 700,
    },
    h1: {
      fontSize: "96px",
      fontWeight: 300,
    },
    h2: {
      fontSize: "60px",
      fontWeight: 300,
    },
    h3: {
      fontSize: "48px",
      fontWeight: 400,
    },
    h4: {
      fontSize: "34px",
      fontWeight: 400,
    },
    h5: {
      fontSize: "24px",
      fontWeight: 400,
    },
    h6: {
      fontSize: "20px",
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 400,
    },
    subtitle3: {
      fontSize: "12px",
      fontWeight: 400,
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
    },
    body3: {
      fontSize: "12px",
      fontWeight: 400,
    },
    button: {
      fontSize: "12px",
      fontWeight: 400,
      textTransform: "uppercase" as const,
    },
    tab: {
      fontSize: "12px",
      fontWeight: 700,
      textTransform: "uppercase" as const,
    },
    caption: {
      fontSize: "12px",
      fontWeight: 400,
    },
    overline: {
      fontSize: "10px",
      fontWeight: 400,
      textTransform: "uppercase" as const,
    },
    pxToRem: (size: number): string => `${(size / htmlFontSize) * coef}rem`,
  },

  shape: {
    borderRadius: 5,
  },

  background: {
    default: "#ffffff",
  },

  gradient: {
    purpleToBlue: "linear-gradient(226.06deg, #0DA6FD -84.18%, #8C33FD 95.34%)",
  },

  elevation: {
    standard: "0px 2px 10px rgba(0,0,0,0.1)",
    strong: "0px 2px 2px rgba(0,0,0,0.15)",
  },

  spacing: 4,
  overrides: {
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "$labelcolor",
        },
      },
    },
  },
};

export default theme;
